// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","titleContainer":"styles_titleContainer__ORtRq","title":"styles_title__r3YGh"};